import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
	colors: {
		gray: {
			"1000": "#333",
			"900": "#181823",
			"800": "#1f2029",
			"700": "#353646",
			"600": "#4b4d63",
			"500": "#616480",
			"400": "#797d9a",
			"300": "#9699b0",
			"200": "#b3b5c6",
			"100": "#d1d2dc",
			"50": "#eeeef2",
			"40": "#f5f5f5",
			"30": "#fafafa"
		},
		blue: {
      "900": "#0D47A1",
      "800": "#1565C0",
      "500": "#2196f3",
      "200": "#90CAF9",
      "100": "#BBDEFB",
		}
	},
	fonts: {
		heading: 'Roboto, Open Sans',
		body: 'Roboto, Open Sans',
	},
	styles: {
		global: {
			body: {
				bg: 'white',
				color: 'gray.900',
				'div::-webkit-scrollbar':  {
    			display: 'none', /* Might be enough */
    			background: 'transparent',
    			visibility: 'hidden',
    			width: '0px'
  			}
			}
		}
	}
})
